import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compare",
  "use": "compare-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"compare\">\n<path d=\"M1.5 5H11.4688V7.25C11.4688 7.5625 11.6562 7.84375 11.9375 7.9375C12.2188 8.0625 12.5312 8.03125 12.75 7.8125L16.25 4.5625C16.5625 4.28125 16.5625 3.75 16.25 3.46875L12.75 0.21875C12.5312 0 12.2188 -0.03125 11.9375 0.0625C11.6562 0.1875 11.4688 0.46875 11.4688 0.75V3H1.5C0.9375 3 0.5 3.46875 0.5 4C0.5 4.5 0.9375 5 1.5 5ZM15.5 11H5.5V8.75C5.5 8.4375 5.3125 8.15625 5.03125 8.0625C4.75 7.96875 4.4375 8 4.21875 8.21875L0.71875 11.4688C0.40625 11.75 0.40625 12.2812 0.71875 12.5625L4.21875 15.8125C4.4375 16.0312 4.75 16.0625 5.03125 15.9375C5.3125 15.8438 5.5 15.5625 5.5 15.25V13H15.5C16.0312 13 16.5 12.5625 16.5 12C16.5 11.4688 16.0312 11 15.5 11Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/compare.svg
// module id = wNDL
// module chunks = 13